import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { getLanguageAndRegionDisplayNames, Locale } from 'libs.i18n-core';
import { RadioGroup, RadioGroupOption, Select, useLocalizeMessage } from 'libs.nucleus';
var LOCALE_EXPORT;
(function (LOCALE_EXPORT) {
    LOCALE_EXPORT["BASE"] = "base";
    LOCALE_EXPORT["CUSTOM"] = "custom";
})(LOCALE_EXPORT || (LOCALE_EXPORT = {}));
export const SectionLocale = memo(({ onChange, locales, initialSelectedIds, isMultipleSelectionEnabled }) => {
    const t = useLocalizeMessage();
    const [localeExport, setLocaleExport] = useState(LOCALE_EXPORT.BASE);
    const initialLocale = locales[initialSelectedIds?.[0] || 0];
    const { languageDisplayName, regionDisplayName } = getLanguageAndRegionDisplayNames({
        appLocale: Locale.en_US,
        targetLocaleCode: initialLocale,
    });
    const initialLocaleSelection = [
        {
            label: `${initialLocale} (${languageDisplayName}/${regionDisplayName})`,
            value: initialLocale.toString(),
        },
    ];
    const [selectedOption, setSelectedOption] = useState(initialLocaleSelection);
    const localeSelectionOptions = locales.map((locale) => {
        const { languageDisplayName, regionDisplayName } = getLanguageAndRegionDisplayNames({
            appLocale: Locale.en_US,
            targetLocaleCode: locale,
        });
        return {
            label: `${locale} (${languageDisplayName}/${regionDisplayName})`,
            value: locale.toString(),
        };
    });
    const handleSetLocaleExport = useCallback((selection) => {
        setLocaleExport(selection);
        setSelectedOption(initialLocaleSelection);
        onChange({
            selectedLocales: [Locale.en_US],
        });
    }, []);
    const handleLocaleSelection = useCallback((selection) => {
        setSelectedOption([selection]);
        onChange({
            selectedLocales: localeExport === LOCALE_EXPORT.BASE ? [Locale.en_US] : [selection.value],
        });
    }, [localeExport]);
    const handleLocaleMultipleSelection = useCallback((selection) => {
        setSelectedOption(selection);
        onChange({
            selectedLocales: selection.map((opt) => opt.value),
        });
    }, [localeExport]);
    return (_jsxs("div", { className: 'flex flex-col gap-5', children: [_jsxs(RadioGroup, { label: t('Locale selection'), value: localeExport, onChange: handleSetLocaleExport, children: [_jsx(RadioGroupOption, { option: {
                            value: LOCALE_EXPORT.BASE,
                            label: t('Only export base language'),
                        } }), _jsx(RadioGroupOption, { option: {
                            value: LOCALE_EXPORT.CUSTOM,
                            label: t('Select locale to export'),
                        } })] }), localeExport === LOCALE_EXPORT.CUSTOM && (_jsx("div", { className: 'flex flex-col gap-5', children: isMultipleSelectionEnabled ? (_jsx(Select, { label: t('Locales'), description: t('Multiple locales can be exported at a time'), multiple: true, value: selectedOption, onChange: handleLocaleMultipleSelection, options: localeSelectionOptions, selectionLabel: selectedOption.length === 1 ? selectedOption[0].label : t(`Locales (${selectedOption.length})`) })) : (_jsx(Select, { label: t('Locales'), description: t('A single locale can be exported at a time'), multiple: false, value: selectedOption[0], onChange: handleLocaleSelection, options: localeSelectionOptions })) }))] }));
});
SectionLocale.displayName = 'SectionLocale';
